export enum IMPERSONATION_RADE_PLATFORM {
  GESTOR,
  ORGANIZACAO,
}
